<h2 class="sectionTitle">{{'FRONT_USER.WORKSPACE.REPRESENTATIVE_LIST'| translate}}</h2>
<form [formGroup]="SearchForm" (ngSubmit)="onSubmit()">
  <div class="services-filter">
    <div class="form-container">
      <h4 class="section-title">{{'FRONT_USER.SEARCH' | translate}}</h4>
      <div class="form-group">
        <label for="SearchName">{{'SHARED.MYTASKS.UserName'| translate}}</label>
        <input type="text" formControlName="SearchName" class="form-control" id="SearchName" name="SearchName" />
      </div>
    </div>
    <div class="btns-holder text-center">
      <button class="btn btn-primary SCAcustomBtn">{{'FRONT_USER.SEARCH' | translate}}</button>
      <button class="btn btn-primary SCAcustomBtn inverse-btn" (click)="reset()">{{'FRONT_USER.RESET' | translate}}</button>
    </div>
  </div>
</form>
<div class="noMenu-table">
    <!-- <app-grid-view #MyRepresentative [IsHtml]="IsHtml" [HasMenu]="HasMenu" (loadItemsMenu)="loadItemsMenu($event)"></app-grid-view> -->
    <app-grid-view #MyRepresentative [customMenuTemplate]="representListTemplate" [IsHtml]="IsHtml" [HasMenu]="HasMenu"></app-grid-view>
  
  <ng-template #representListTemplate let-item let-menuItems="menuItems">
   
  
    <li role="menuitem" *ngIf="item.Status == 'Active' || item.Status == 'مفعل' ">
        <a class="dropdown-item" (click)="DeActivate(item.RequestId)">
           {{'FRONT_USER.Deactivate'|translate}}
        </a>
    </li>
    <li role="menuitem" *ngIf="item.Status == 'InActive' || item.Status == 'غير مفعل' ">
        <a class="dropdown-item" (click)="Activate(item.RequestId)">
           {{'FRONT_USER.Activate'|translate}}
        </a>
    </li>
   
  </ng-template>
</div>